import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type SyncDossierTransactionsPayload = {
  dossierId: string;
  dateFrom: string;
  dateTo: string;
};

export const syncDossierTransactions = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSettled } = useAPQuery();

  return useMutation({
    mutationFn: (payload: SyncDossierTransactionsPayload): Promise<boolean> => {
      return fetchWithAuth<boolean>(
        "syncDossierTransactions",
        payload.dossierId,
        {
          requestOptions: { method: "post", body: JSON.stringify(payload) },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: (result: boolean, payload: SyncDossierTransactionsPayload) => {
      const onError = defaultOnMutateError(options);

      if (result) {
        defaultOnMutateSettled([
          ["syncDossierTransactionsStatus", payload.dossierId],
        ]);
      } else {
        onError();
      }
    },
  });
};
